import React, { useState } from "react";
import PhotoCameraBackIcon from "@mui/icons-material/PhotoCameraBack";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { imgUrl } from "../../../api/api";
import { ReactComponent as JpgIcon } from "../../../Assets/images/jpgIcon.svg";
import ScheduleSendIcon from "@mui/icons-material/ScheduleSend";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Divider, Menu, MenuItem } from "@mui/material";
import { Document, Page } from "react-pdf";
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import { Layers } from "lucide-react";
import { CopyAllOutlined } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { copyTemplate } from "../../../Redux/Actions/contentAction";
import toast from "react-hot-toast";
import { useContextUserId } from "../../../hooks/useSupportContext";
function Template({ data, addSchedule, deleteSingleContent, readOnly = false }) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.User);
  const contextUserId = useContextUserId();
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
   const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
   
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = (type, obj) => {
      setAnchorEl(null);
    };

    const handleCopyTemplate = () => {
      if (data.type === "template") {
        dispatch(copyTemplate(data.id, contextUserId));
        toast.success("Template copied successfully!");
        setAnchorEl(null);
      } else {
        toast.error("Only templates can be copied");
      }
    };
  return (
    <>
      <div className="content-item" key={data.key}>
        <div className="content-image">
          {!readOnly && (
            <div className="content-del-icon">
              <MoreVertIcon
                onClick={handleClick}
                style={{ color: "var(--primary-color)" }}
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              />
              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
              >
                <MenuItem onClick={handleCopyTemplate}>
                  <CopyAllOutlined
                    style={{ color: "var(--primary-color)", marginRight: "8px" }}
                  />
                  Copy
                </MenuItem>
                <Divider />
                <MenuItem onClick={() => deleteSingleContent(data.id)}>
                  <DeleteOutlineIcon
                    style={{ color: "var(--primary-color)", marginRight: "8px" }}
                  />
                  Delete
                </MenuItem>
              </Menu>
            </div>
          )}
           <div style={{ height: "230px", width: "230px",display:"flex",justifyContent:"center",alignItems:"center" }}>
          <Layers 
            style={{
              height:'80%',
              width:'80%',

            }}
          />
          </div> 
          {/* <img src={`${imgUrl}/${data.url}`} alt="" /> */}
        </div>
        <div className="content-bottom">
          <p>{data?.name?.substring(0, 20)}</p>
          <p
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span>
              <Layers
                style={{
                  fontSize: "17px",
                  color:"var(--primary-color)"
                }}
              />
            </span>
            <span>{data.type=="template" && "Template"}</span>
          </p>
        </div>
      </div>
    </>
  );
}

export default Template;
